import React, {useEffect} from 'react'

const RedirectProd: React.FC = () => {
    useEffect(() => {
        window.location.replace('/precadastro-pacientes')
    }, [])

    return <div></div>
}

export default RedirectProd